<template>
  <div>
  <v-row>
    <v-col cols="6" sm="6" md="3">
      <v-card class="primary darken-1">
        <v-row class="align-start justify-start ml-2 mr-2">
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
            <!--              <span style="color: lightgrey; font-size: small">Atualizado em {{ affluentFlow.updated.split('T')[0] }} às {{ affluentFlow.updated.split('T')[1] }}</span>-->
          </v-col>
        </v-row>
        <v-card-title class="mt-n5">
          <v-icon color="secondary" class="mb-2">
            mdi-account-group-outline
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="font-weight-bold white--text">População total</v-card-subtitle>
        <v-card-text>
          <!--            <v-row v-if="!affluentFlow">
                        <v-col cols="3">
                          <v-icon color="orange" right>mdi-information-outline</v-icon>
                        </v-col>
                        <v-spacer/>
                        <v-col cols="9">
                          <span style="color: orange">Os dados de demanda média estão indisponíveis no momento.</span>
                        </v-col>
                      </v-row>-->
<!--          <v-row class="white&#45;&#45;text">
            <v-col cols="12" sm="12" md="12" class="align-center justify-center">
              &lt;!&ndash;                <strong class="display-1 font-weight-bold">{{ affluentFlow.flow }} </strong>&ndash;&gt;
              <strong class="display-1 font-weight-bold">456.654 </strong>
              <span>pessoas</span>
            </v-col>
            <v-col cols="12">
              <span>Pessoas atendidas pela estação.</span>
            </v-col>
          </v-row>-->
          <v-row class="white--text">
            <v-col class="pa-3" cols="12">
              <h2>Em breve</h2>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6" sm="6" md="3">
      <v-card class="primary darken-1">
        <v-row class="align-start justify-start ml-2 mr-2">
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
            <!--              <span style="color: lightgrey; font-size: small">Atualizado em {{ affluentFlow.updated.split('T')[0] }} às {{ affluentFlow.updated.split('T')[1] }}</span>-->
          </v-col>
        </v-row>
        <v-card-title class="mt-n5">
          <v-icon color="secondary" class="mb-2">
            mdi-waves
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="font-weight-bold white--text">Demanda média</v-card-subtitle>
        <v-card-text>
          <!--            <v-row v-if="!affluentFlow">
                        <v-col cols="3">
                          <v-icon color="orange" right>mdi-information-outline</v-icon>
                        </v-col>
                        <v-spacer/>
                        <v-col cols="9">
                          <span style="color: orange">Os dados de demanda média estão indisponíveis no momento.</span>
                        </v-col>
                      </v-row>-->
<!--          <v-row class="white&#45;&#45;text">
            <v-col cols="12" sm="12" md="12" class="align-center justify-center">
              &lt;!&ndash;                <strong class="display-1 font-weight-bold">{{ affluentFlow.flow }} </strong>&ndash;&gt;
              <strong class="display-1 font-weight-bold">2738 </strong>
              <span>l/s</span>
            </v-col>
            <v-col cols="12">
              <span>Média diária na estação.</span>
            </v-col>
          </v-row>-->
          <v-row class="white--text">
            <v-col class="pa-3" cols="12">
              <h2>Em breve</h2>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6" sm="6" md="3">
      <v-card class="primary darken-1 quality">
        <v-row class="align-start justify-start ml-2 mr-2">
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
          </v-col>
        </v-row>
        <v-card-title class="mt-n5">
          <v-icon color="secondary" class="mb-2">
            mdi-beer-outline
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="font-weight-bold white--text">Qualidade da água</v-card-subtitle>
        <v-card-text>
          <!--            <v-row v-if="quality">
                        <v-col cols="3">
                          <v-icon color="orange" right>mdi-information-outline</v-icon>
                        </v-col>
                        <v-spacer/>
                        <v-col cols="9">
                          <span style="color: orange">Os dados de qualidade da água estão indisponíveis no momento.</span>
                        </v-col>
                      </v-row>-->
          <v-row class="white--text">
            <v-col class="pa-3" cols="12">
              <h2>Em breve</h2>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6" sm="6" md="3">
      <v-card class="primary darken-1">
        <v-row class="align-start justify-start ml-2 mr-2">
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span v-if="!flow" style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
            <span v-else style="color: lightgrey; font-size: small">Atualizado em {{ formatDate(flow.date) }}</span>
          </v-col>
        </v-row>
        <v-card-title class="mt-n5">
          <v-icon color="secondary" class="mb-2">
            mdi-waves
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="font-weight-bold white--text">Vazão afluente</v-card-subtitle>
        <v-card-text>
          <v-row v-if="!flow">
            <v-col cols="3">
              <v-icon color="orange" right>mdi-information-outline</v-icon>
            </v-col>
            <v-spacer/>
            <v-col cols="9">
              <span style="color: orange">Os dados de vazão afluente estão indisponíveis no momento.</span>
            </v-col>
          </v-row>
          <v-row v-else class="white--text">
            <v-col cols="12" sm="12" md="12" class="align-center justify-center">
              <strong v-if="flow" class="display-1 font-weight-bold">{{ flow.value[0].flow.toFixed(3) }} </strong>
              <span>m³/s</span>
            </v-col>
            <v-col cols="12">
              <span>Relativa ao ponto de captação.</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ['flow'],
  name: "CurrentStationCards",
  methods:{
    formatDate(val){
      return moment(val, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }
  },
}
</script>

<style scoped>
.quality.v-card.v-sheet.theme--dark {
  border-left: 7px solid white !important;
}
.v-card.v-sheet.theme--dark {
  min-height: 285px;
  /*min-width: 250px;*/
  max-height: 300px;
  /*max-width: 345px;*/
}
</style>
